module.exports = __webpack_public_path__ + "c2h4static/img/report-img-egg-04-pre@2x.8ab1490.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Result/imgs/report-img-egg-04-pre@2x.png
// module id = S3fL
// module chunks = 1